import { render } from "./PuzzleGame.vue?vue&type=template&id=4ba8a227&scoped=true"
import script from "./PuzzleGame.vue?vue&type=script&lang=js"
export * from "./PuzzleGame.vue?vue&type=script&lang=js"

import "./PuzzleGame.vue?vue&type=style&index=0&id=4ba8a227&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba8a227"]])

export default __exports__